export enum EOverrideSetting {
  OS_Additive,
  OS_Override,
}

export const EOverrideSettingDisplayName = {
  [EOverrideSetting.OS_Additive]: 'Additive',
  [EOverrideSetting.OS_Override]: 'Override',
};
